export default "__VITE_ASSET__5c64e9da__"